import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionTitle from "../SectionTitle";

const services = [
  {
    id: 1,
    title: "Korekcija vek",
    description: "Pomladitev področja okoli oči za bolj svež in spočit videz.",
    icon: "👁️",
    slug: "korekcija-vek"
  },
  {
    id: 2,
    title: "Povečanje prsi",
    description: "Harmonično oblikovanje prsi z naprednimi tehnikami.",
    icon: "✨",
    slug: "povecanje-prsi"
  },
  {
    id: 3,
    title: "Pomladitev obraza",
    description: "Naravno pomlajen videz obraza z minimalnimi posegi.",
    icon: "🧬",
    slug: "pomladitev-obraza"
  },
  {
    id: 4,
    title: "Oblikovanje telesa",
    description: "Preoblikovanje telesa za poudarek naravnih linij in proporcij.",
    icon: "🧠",
    slug: "oblikovanje-telesa"
  }
];

const FeaturedServices = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-6 md:px-8">
        <SectionTitle
          title="Naše storitve"
          subtitle="Odkrijte naše vrhunske estetske in rekonstruktivne storitve, prilagojene vašim individualnim potrebam."
          className="mb-12 md:mb-16"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="glass-card hover:bg-gradient-to-br hover:from-white hover:to-medical-50/30 p-6 md:p-8 transition-all duration-300 hover:translate-y-[-5px] opacity-0 animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-3xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              <Link 
                to={`/storitev/${service.slug}`} 
                className="inline-flex items-center text-medical-600 hover:text-medical-700 font-medium"
              >
                Več o storitvi
                <ArrowRight size={16} className="ml-2" />
              </Link>
            </div>
          ))}
        </div>
        
        <div className="mt-10 md:mt-12 text-center">
          <Link 
            to="/storitve" 
            className="inline-flex items-center text-medical-600 hover:text-medical-700 font-medium text-lg"
          >
            Vse storitve
            <ArrowRight size={18} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedServices;